import fetch from '../utils/fetch';

export function list(params) {
    return fetch({
      method: 'POST',
      url: '/managerReckonSwth/list',
      data:params
    })
  }

  export function updateAppointStatus(params) {
    return fetch({
      method: 'POST',
      url: '/managerReckonSwth/updateAppointStatus',
      data:params
    })
  }

export function findWorkOrderTypeListV2(params) {
  return fetch({
    method: 'POST',
    url: '/workOrder/findWorkOrderTypeList/V2',
    data:params
  })
}
